import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=725e21fc&scoped=true&"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=725e21fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725e21fc",
  null
  
)

export default component.exports